import Vue, { VueConstructor } from 'vue'

import App from './App.vue'

import '../../../stylesheets/namespace/Magazine.css'
import '../../../stylesheets/namespace/MagazineSidebar.css'

const mountEl = document.querySelector('#magazine-landing') as HTMLElement

const install = (mountEl: HTMLElement, component: VueConstructor<Vue>) => {
  if (!mountEl) {
    return false
  }

  new Vue({
    render: h => h(component, {
      props: {}
    })
  }).$mount(mountEl)
}

install(mountEl, App)
